import React from "react";
import { graphql, PageProps } from "gatsby";
import { Link } from "gatsby-plugin-react-i18next";
import { useTranslation } from "react-i18next";
import { gtag, useGtagNavigate } from "../../hooks/use-gtag-navigate";
import ExternalLink from "../elements/external-link";


const CtaWidget: React.FC<PageProps> = (props) => {
    const { t } = useTranslation();

    const refUrl = props.location.pathname.split("/");
    return (
        <section id="cta-widget" className="py-6 bg-light-primary">
            <div className="container">
                <div className="card btn-contact-us light-shadow p-4 p-lg-6 ">
                    <div className="row row-cols-1 row-cols-lg-2 align-items-center">
                        <div className="col mb-4 mb-lg-0">
                            <h4 className="font-weight-bold">{t("btn_cta_reg")}</h4>
                            <p className="text-dark mb-0">{t("btn_cta_reg_store")}</p>
                        </div>
                        <div className="col text-lg-right d-flex justify-content-around">
                            <Link to={`/contact-us?click=${refUrl[refUrl.length - 1]}`} id="btn-contact-us" className="btn bg-white btn-white d-block d-md-inline-block ">
                                {t("menu.contact")}
                            </Link>
                            <ExternalLink onClick={()=>{gtag()}} className={"btn btn-primary d-block text-decoration-none"} href={`https://www.mystoreberry.com/auth/registration`} queryParams={{click:refUrl[refUrl.length - 1]}} >
                               <div>
                               {t("btn_cta_contact_us")}
                               </div>
                            </ExternalLink>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default CtaWidget;

// export const query = graphql`
//     query ($language: String!) {
//         locales: allLocale(filter: { language: { eq: $language } }) {
//             edges {
//                 node {
//                     ns
//                     data
//                     language
//                 }
//             }
//         }
//     }
// `;
